<div class="flex items-center justify-center p-4 pt-20">
  <edu-error
    [header]="
      'shared.pages.missingFeature.title'
        | transloco: { feature: ('shared.features.' + missingFeature() + '.label' | transloco) }
    "
    [description]="
      'shared.pages.missingFeature.description'
        | transloco: { feature: ('shared.features.' + missingFeature() + '.label' | transloco) }
    "
  />
</div>
